import VueI18n from "vue-i18n";
import Vue from "vue";
import en from "../locales/en.json";

Vue.use(VueI18n);

const messages = {
  en
};

export const i18n = new VueI18n({
  locale: navigator.language.split("-")[0],
  fallbackLocale: "en",
  messages
});
